// extracted by mini-css-extract-plugin
module.exports = {"root":"AfterBackImages_root__1TUE4","title":"AfterBackImages_title__31LJs","images":"AfterBackImages_images__3crKz"};